import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import Header from './Component/Header';
import './Component/apl.css'
import {BrowserRouter} from 'react-router-dom'
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Header/>
    <App />
    </BrowserRouter>
  </React.StrictMode>
);


